import React, { useEffect, useRef, useState } from "react";
import PageTab from "@/components/i-pageTab/i-pageTab";
import PageTable from "@/components/i-pageTable/i-pageTable";
import {
  fictitiousOrderList,
  fictitiousOrderDetail,
  fictitiousOrderAdd,
  fictitiousOrderEdit,
  fictitiousOrderDelete,
  fictitiousConfigDetail,
  fictitiousConfigEdit,
  fictitiousConfigAdd,
} from "@/api/other";
import { Button, Descriptions, Input, InputNumber, message, Modal, Space } from "antd";
import {
  customRequest,
  setIcons,
} from "@/utils/common";

import { dictInfoAsync } from "@/stores/dictInfo";
import { userEditFormTab, items, columns } from "./helps";
import dayjs from "dayjs";

interface IndustryConfigItem {
  industryName?: string;
  industryRate?: number;
}

const normalizeIndustryConfigList = (data: any): IndustryConfigItem[] => {
  if (Array.isArray(data?.industryConfigDtoList)) {
    return data.industryConfigDtoList;
  }

  if (typeof data?.industryConfig === "string" && data.industryConfig) {
    try {
      const list = JSON.parse(data.industryConfig);
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  return [];
};

export default function LargeManager() {
  const [pageData, setPageData] = useState<SelectCmsAppUserPageRes["rows"]>([]);
  const [userOutPageData, setUserOutPageData] = useState<
    ListUserAccountChangesByIdRes["rows"]
  >([]);
  const [mainPicUploadProgress, setMainPicUploadProgress] = useState(false);

  const [total, setTotal] = useState(0);
  const [userOutTotal, setUserOutTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [categoryList, setCategoryList] = useState([]);

  const [modalFormData, setModalFormData] = useState<any>(items);

  const [formData, setFormData] = useState<any>({
    ypageNum: 1,
    ypageSize: 10,
  });

  const [userOutFormData, setUserOutFormData] = useState({
    userId: "",
    ypageNum: 1,
    ypageSize: 10,
  });

  const [modalFormuserEdit, setModalFormuserEdit] = useState<any>({
    image: [],
  });

  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState<any>({});

  const userEditFormTabList = userEditFormTab(
    modalFormuserEdit,
    setModalFormuserEdit,
    mainPicUploadProgress,
    setMainPicUploadProgress,
    setIcons,
    customRequest
  );


  useEffect(() => {
    getPageData();
  }, [formData]);

  

  useEffect(() => {
    userOutFormData.userId && getUserOutList();
  }, [userOutFormData]);

  useEffect(() => {
    getFictitiousConfig();
  }, []);

  const getFictitiousConfig = async () => {
    const { data } = await fictitiousConfigDetail();
    console.log(data, "data");
    if (!data || Object.keys(data).length === 0) return;
    let newData: any = [];
    items!.forEach((item: any) => {
      newData.push({
        ...item,
        children: data[item.key]
      })
    });
    console.log(newData, "newData", items);

    setModalFormData(newData);
    const initialEditData: any = {};
    Object.keys(data).forEach(key => {
      initialEditData[key] = data[key];
    });
    setEditData({
      ...initialEditData,
      industryConfigDtoList: normalizeIndustryConfigList(data),
    });
  }

  const getPageData = async () => {
    setLoading(true);
    try {
      const data = await fictitiousOrderList({ ...formData, delFlag: "0" });
      setPageData(data.rows);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const deteletDetail = async (val: string) => {
    Modal.confirm({
      title: "确定要删除当前订单吗？",
      onOk: async () => {
        await fictitiousOrderDelete(val);
        message.success("删除成功");
        getPageData();
      },
    });
  };
 

  const getUserOutList = async () => {
    try {
    } catch (error) {}
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };

  const outDetail = async (val: string) => {
    try {
      const { data } = await fictitiousOrderDetail(val);
      setModalFormuserEdit({
        ...data,
        image: data.userAvatar
          ? [{ url: data.userAvatar, uid: data.userAvatar, name: "" }]
          : [],
        userCreateTime: data.userCreateTime ? dayjs(data.userCreateTime, 'HH:mm:ss') : null,
      });
      setOpen(true);
    } catch (error) {}
  };

  const confirmUser = async (val: any) => {
    try {
      let data;
      if (!modalFormuserEdit?.orderId) {
        data = await fictitiousOrderAdd({
          ...val,
          userAvatar: val?.image?.[0]?.url,
          userCreateTime: val?.userCreateTime ? dayjs(val.userCreateTime).format("HH:mm:ss") : null,
        });
      } else {
        data = await fictitiousOrderEdit({
          ...val,
          userAvatar: val?.image?.[0]?.url,
          userCreateTime: val?.userCreateTime ? dayjs(val.userCreateTime).format("HH:mm:ss") : null,
        });
      }
      message.success(data.msg);
      setOpen(false);
      getPageData();
      setModalFormuserEdit({
        image: [],
      });
    } catch (error) {}
  };

  const resetEditUser = () => {
    setModalFormuserEdit({
      image: [],
    });
    setOpen(false);
  };

  const handleSave = async () => {
    try {
      const industryConfigDtoList = (editData.industryConfigDtoList || [])
        .filter((item: IndustryConfigItem) => item.industryName || item.industryRate)
        .map((item: IndustryConfigItem) => ({
          industryName: item.industryName,
          industryRate: Number(item.industryRate || 0),
        }));
      const industryRateTotal = industryConfigDtoList.reduce(
        (total: number, item: IndustryConfigItem) =>
          total + Number(item.industryRate || 0),
        0
      );

      if (industryConfigDtoList.some((item: IndustryConfigItem) => !item.industryName)) {
        message.error("请填写行业名称");
        return;
      }

      if (industryRateTotal > 100) {
        message.error("行业分布占比不能超过100%");
        return;
      }

      if (industryRateTotal !== 100) {
        message.error("行业分布占比合计必须等于100%");
        return;
      }

      const submitData = {
        ...editData,
        industryConfig: JSON.stringify(industryConfigDtoList),
        industryConfigDtoList,
      };

      // 这里添加保存到后端的接口调用
      if (!editData?.id) {
        await fictitiousConfigAdd(submitData);
      } else {
        await fictitiousConfigEdit(submitData);
      }
      setIsEditing(false);
      message.success('保存成功');
      getFictitiousConfig(); // 重新获取数据
    } catch (error) {
      message.error('保存失败');
    }
  }

  const handleIndustryAdd = () => {
    setEditData((prev: any) => ({
      ...prev,
      industryConfigDtoList: [
        ...(prev.industryConfigDtoList || []),
        {
          industryName: "",
          industryRate: 0,
        },
      ],
    }));
  };

  const handleIndustryChange = (
    index: number,
    field: keyof IndustryConfigItem,
    value: number | string | null
  ) => {
    setEditData((prev: any) => {
      const list = [...(prev.industryConfigDtoList || [])];
      list[index] = {
        ...list[index],
        [field]: field === "industryRate" ? Number(value || 0) : value,
      };

      return {
        ...prev,
        industryConfigDtoList: list,
      };
    });
  };

  const handleIndustryDelete = (index: number) => {
    setEditData((prev: any) => ({
      ...prev,
      industryConfigDtoList: (prev.industryConfigDtoList || []).filter(
        (_item: IndustryConfigItem, currentIndex: number) => currentIndex !== index
      ),
    }));
  };

  const handleConfigChange = (key: string, value: string) => {
    setEditData((prev: any) => {
      const nextData = {
        ...prev,
        [key]: value,
      };
      const activateDeviceCount = Number(nextData.activateDeviceCount || 0);

      if (key === "activateOnlineDeviceCount") {
        const onlineCount = Number(value || 0);
        nextData.activateOfflineDeviceCount = Math.max(
          activateDeviceCount - onlineCount,
          0
        );
      }

      if (key === "activateOfflineDeviceCount") {
        const offlineCount = Number(value || 0);
        nextData.activateOnlineDeviceCount = Math.max(
          activateDeviceCount - offlineCount,
          0
        );
      }

      return nextData;
    });
  };

  const industryConfigList: IndustryConfigItem[] = editData.industryConfigDtoList || [];
  const industryRateTotal = industryConfigList.reduce(
    (total, item) => total + Number(item.industryRate || 0),
    0
  );
  const industryItems = industryConfigList.length
    ? industryConfigList.map((item, index) => ({
        key: index,
        label: item.industryName || "行业名称",
        children: isEditing ? (
          <Space>
            <Input
              placeholder="行业名称"
              style={{ width: 160 }}
              value={item.industryName}
              onChange={(e) =>
                handleIndustryChange(index, "industryName", e.target.value)
              }
            />
            <InputNumber
              addonAfter="%"
              min={0}
              max={100}
              placeholder="占比率"
              style={{ width: 140 }}
              value={item.industryRate}
              onChange={(value) =>
                handleIndustryChange(index, "industryRate", value)
              }
            />
            <Button danger type="text" onClick={() => handleIndustryDelete(index)}>
              删除
            </Button>
          </Space>
        ) : (
          `${item.industryRate}%`
        ),
      }))
    : [
        {
          key: "empty",
          label: "行业分布",
          children: "-",
        },
      ];

  return (
    <div>
      <Descriptions
        bordered
        title="虚拟配置"
        size={"small"}
        extra={
          isEditing ? (
            <Space>
              <Button onClick={() => setIsEditing(false)}>取消</Button>
              <Button type="primary" onClick={handleSave}>
                保存
              </Button>
            </Space>
          ) : (
            <Button type="primary" onClick={() => setIsEditing(true)}>
              编辑
            </Button>
          )
        }
        items={modalFormData.map((item: any) => ({
          ...item,
          children: isEditing ? (
            <Input
              value={editData[item.key]}
              onChange={(e) => handleConfigChange(item.key as string, e.target.value)}
            />
          ) : (
            item.children
          )
        }))}
        column={4}
      />

      <div style={{ marginTop: "24px" }}>
        <Descriptions
          bordered
          title={
            <Space>
              <span>行业分布</span>
              {isEditing && (
                <span
                  style={{
                    color: industryRateTotal === 100 ? "#52c41a" : "#ff4d4f",
                    fontWeight: 400,
                  }}
                >
                  当前合计：{industryRateTotal}%
                </span>
              )}
            </Space>
          }
          size="small"
          extra={
            isEditing ? (
            <Button
              icon={setIcons("PlusOutlined")}
              onClick={handleIndustryAdd}
            >
              新增行业
            </Button>
            ) : null
          }
          items={industryItems}
          column={3}
        />
      </div>
      
      <Modal
        destroyOnHidden={true}
        open={open}
        title="虚拟订单"
        width="380px"
        footer={<></>}
        onCancel={resetEditUser}
      >
        <PageTab
          subFoot
          search={confirmUser}
          reset={resetEditUser}
          formTab={userEditFormTabList as any}
          initialValues={modalFormuserEdit}
        ></PageTab>
      </Modal>
      <div style={{ marginTop: "24px" }}>
      <Button
        icon={setIcons("PlusOutlined")}
        type="primary"
        onClick={() => setOpen(true)}
      >
        新增
      </Button>
      </div>
      <PageTable
        loading={loading}
        pageChange={pageChange}
        size="small"
        rowKey="orderId"
        columns={columns(outDetail, deteletDetail)}
        data={pageData}
        pagination={{
          current: formData.ypageNum!,
          pageSize: formData.ypageSize!,
          total: total,
        }}
      ></PageTable>
    </div>
  );
};
